// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"286489dd","911":"82639108"}[chunkId] + ".chunk.js";
};